import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import styled from "styled-components";
import ErrorMessage from "./errorMessage";

export enum HttpRequestStatus {
  IDLE = "idle",
  ERROR = "error",
  LOADING = "loading",
  SUCCESS = "success",
}

const Container = styled.div<{ size?: "sm" | "md" | "full" }>`
  width: 100%;
  max-width: ${({ size }) =>
    size === "sm" ? "20rem" : size === "md" ? "30rem" : "100%"};
  margin: 20px auto;
`;

const Loader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

type Props = {
  status: HttpRequestStatus;
  excludeContainers?: boolean;
  containerSize?: "sm" | "md" | "full";
  children?: any;
  errorMessage?: string;
};

export function getStatusElement(
  status: HttpRequestStatus,
  errorMessage: string | undefined
) {
  if (status === HttpRequestStatus.LOADING) {
    return (
      <Loader>
        <ProgressSpinner
          data-testid="loading-indicator"
          color="var(--mim-teal)"
        />
      </Loader>
    );
  }

  if (errorMessage) {
    return <ErrorMessage summary={errorMessage} type="error" />;
  }

  return null;
}

export const LoadingContainer = ({
  status,
  children,
  excludeContainers,
  containerSize,
  errorMessage,
}: Props) => {
  const statusElement = getStatusElement(status, errorMessage);

  if (statusElement != null) {
    return excludeContainers ? (
      statusElement
    ) : (
      <Container size={containerSize}>{statusElement}</Container>
    );
  }

  return children;
};
